import React from "react";
import { Table } from "react-bootstrap";
import styled from "styled-components";

import { formatDocument, showSnackBar } from "../../../../../../utils";
import FilterClients from "../../../../../AppViews/Clients/components/Filter";

import ResponsiveContainer from "../../../../../../_components/ResponsiveContainer";
import { CreateNFeContext } from "../../Context";
import Button from "../../../../../../_components/Button";
import Text from "../../../../../../_components/Text";
import Modal from "../../../../../../_components/Modal";

import * as colors from "../../../../../../assets/_base/colors";

const IconUser = styled.i`
  color: ${colors.darkBlue};
`;

export default function Recipient(props) {
  const [show, showModal] = React.useState(false);

  const context = React.useContext(CreateNFeContext);

  function openModal() {
    showModal(true);
  }
  function closeModal() {
    showModal(false);
  }

  function onSet(client){
    if (!client.address.city_id) {
        showSnackBar("Os dados de endereço estão inválidos. Por favor, atualize as informações de endereço do cliente.", "danger", 10000)
        return
    }
    const { nfe } = context
    nfe.identification.recipient = client.original_id
        nfe.identification.recipient_name = client.name
        nfe.identification.recipient_cpf_cnpj = client.individual
            ? client.individual.cpf : client.company.cnpj
        nfe.identification.recipient_phone_number = client.phone_number
        nfe.identification.recipient_city_name = client.address.city
        nfe.identification.recipient_state_uf = client.address.state
        context.handlers.updateNFeData(nfe);
        closeModal();
  }

  function onRemove() {
    const { nfe } = context;
    nfe.identification.recipient = ""
    nfe.identification.recipient_name = ""
    nfe.identification.recipient_cpf_cnpj = ""
    nfe.identification.recipient_city_name = ""
    nfe.identification.recipient_state_uf = ""
    nfe.identification.recipient_phone_number = ""
    context.handlers.updateNFeData(nfe);
  }

  return (
    <div>
      {context.nfe.identification.recipient_name ? (
        <ResponsiveContainer
          mobileComponent={
            <CardClient
              name={context.nfe.identification.recipient_name}
              cpf_cnpj={context.nfe.identification.recipient_cpf_cnpj}
              city_name={context.nfe.identification.recipient_city_name}
              state_uf={context.nfe.identification.recipient_state_uf}
              onClick={onRemove}
            />
          }
          desktopComponent={
            <TableClient
              name={context.nfe.identification.recipient_name}
              cpf_cnpj={context.nfe.identification.recipient_cpf_cnpj}
              city_name={context.nfe.identification.recipient_city_name}
              state_uf={context.nfe.identification.recipient_state_uf}
              phone_number={context.nfe.identification.recipient_phone_number}
              onClick={onRemove}
            />
          }
        />
      ) : (
        <React.Fragment>
          <div className="">
            <Text color="primary">Destinatário / Tomador (Cliente) *</Text>
            <div className="text-center ">
              <IconUser className="fas fa-user fa-4x my-4" />
            </div>
            <div className="d-flex justify-content-center">
              <Button data-cy-test="#nfe-issuer-click-select-client" onClick={openModal}>Selecionar destinatário</Button>
            </div>
          </div>
        </React.Fragment>
      )}
      <Modal title="Selecione o cliente" show={show} onHide={closeModal}>
        <FilterClients
          onClick={onSet}
        />
      </Modal>
    </div>
  );
}

function CardClient(props) {
  return (
    <React.Fragment>
      <p className="lead h2">Destinatário / Tomador (Cliente)</p>
      <div>
        <ul className="list-group">
          <li className="list-group-item">
            Destinatário: <strong>{props.name}</strong>
          </li>
          <li className="list-group-item">
            CPF/CNPJ: <strong>{formatDocument(props.cpf_cnpj)}</strong>
          </li>
          <li className="list-group-item">
            Cidade/Estado:{" "}
            <strong>
              {props.city_name}/{props.state_uf}
            </strong>
          </li>
          <li
            className="list-group-item"
            style={{ cursor: "pointer" }}
            onClick={props.onClick}
          >
            <strong className="text-danger">remover cliente</strong>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
}

function TableClient(props) {
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Ações</th>
          <th>Destinatário (Cliente)</th>
          <th>CPF/CNPJ</th>
          <th>Cidade/Estado</th>
          <th>Telefone</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            className="text-center"
            style={{ cursor: "pointer" }}
            onClick={props.onClick}
          >
            <i className="fa fa-trash" aria-hidden="true"></i>
          </td>
          <td>{props.name}</td>
          <td>{formatDocument(props.cpf_cnpj)}</td>
          <td>
            {props.city_name}/{props.state_uf}
          </td>
          <td>{props.phone_number}</td>
        </tr>
      </tbody>
    </Table>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Recipient/index.jsx